import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';
import { Server } from '#enums';
import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  private http = inject(HttpClient);

  public getProjectById(projectId: number) {
    return this.http.get<Dtos.Project>(`${environment.apiUrl}/project/${projectId}`);
  }

  public addProject(project: Dtos.Project): Observable<Dtos.Project> {
    return this.http.post<Dtos.Project>(`${environment.apiUrl}/project`, project);
  }

  public updateProject(project: Dtos.Project): Observable<Dtos.Project> {
    return this.http.put<Dtos.Project>(`${environment.apiUrl}/project`, project);
  }

  // public downloadLoadSheet(project: Dtos.Project): Observable<object> {
  //   const result = this.http.post<object>(`${environment.apiUrl}/project/downloadEAMLoadSheet`, project, {
  //     responseType: 'blob' as 'json',
  //   });
  //   return result;
  // }

  // public downloadEquipmentList(project: Dtos.Project): Observable<object> {
  //   const result = this.http.post<object>(`${environment.apiUrl}/project/downloadEquipmentList`, project, {
  //     responseType: 'blob' as 'json',
  //   });
  //   return result;
  // }

  // public getFullListByOrgId(orgId: number) {
  //   return this.http.get<Dtos.Project[]>(`${environment.apiUrl}/project/fullList/${orgId}`);
  // }

  public getByOrgId(orgId: number) {
    return this.http.get<Dtos.Project[]>(`${environment.apiUrl}/project/getByOrgId/${orgId}`);
  }

  // public getByEquipmentExists(orgId: number): Observable<Dtos.Project[]> {
  //   return this.http.get<Dtos.Project[]>(`${environment.apiUrl}/project/getByEquipExist/${orgId}`);
  // }

  public addParticipant(projectUsers: Dtos.ProjectUser[]): Observable<Dtos.ProjectUserList> {
    return this.http.post<Dtos.ProjectUserList>(`${environment.apiUrl}/project/addParticipant`, projectUsers);
  }

  public removeParticipant(id: number): Observable<Dtos.ProjectUser> {
    return this.http.put<Dtos.ProjectUser>(`${environment.apiUrl}/project/removeParticipant/${id}`, null);
  }

  // public copyFromProject(fromProj: number, toProj: number): Observable<Dtos.ResultModel> {
  //   return this.http.get<Dtos.ResultModel>(`${environment.apiUrl}/project/copyFromProject/${fromProj}/${toProj}`);
  // }

  // public downloadABChecks(projId: number) {
  //   return this.http.get(`${environment.apiUrl}/project/downloadABChecks/${projId}`, { responseType: 'blob' });
  // }

  public delete(id: number, deletePSSRs: boolean) {
    return this.http.put<void>(`${environment.apiUrl}/project/delete/${id}/${deletePSSRs}`, null);
  }

  getLabelClass(project: Dtos.Project): string {
    if (project.IsDeleted) {
      return 'label-deleted';
    }
    if (project.Status === Server.ProjectStatus.Active) {
      return 'label-approved';
    }
    if (project.Status === Server.ProjectStatus.Closed) {
      return 'label-closed';
    }
    return 'label-cancel';
  }

  searchProjectsList({
    organizationID = 0,
    isDeleted = false,
    statuses = [Server.ProjectStatus.Active],
    minRangeDate,
    maxRangeDate,
  }: Dtos.ProjectFilter) {
    let params = new HttpParams().set('isDeleted', `${isDeleted}`).set('organizationID', `${organizationID}`);

    if (minRangeDate !== null) {
      params = params.append('minRangeDate', minRangeDate.toISOString());
    }

    if (maxRangeDate !== null) {
      params = params.append('maxRangeDate', maxRangeDate.toISOString());
    }

    for (const status of statuses) {
      params = params.append('statuses', `${status}`);
    }

    return this.http.get<Dtos.Project[]>(`${environment.apiUrl}/project?`, {
      params,
    });
  }
  restoreProject(projectId: number) {
    return this.http.put(`${environment.apiUrl}/project/${projectId}/restore`, {});
  }
}
